import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useRef, useState, useEffect } from 'react';

var useIntervalTrigged = function useIntervalTrigged(callback, intervalDuration) {
  var startImmediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var internalIdRef = useRef(null);
  var _useState = useState(startImmediate),
    _useState2 = _slicedToArray(_useState, 2),
    isRunning = _useState2[0],
    setIsRunning = _useState2[1];
  var savedCallback = useRef();
  function start() {
    if (!isRunning) {
      setIsRunning(true);
    }
  }
  function stop() {
    if (internalIdRef.current) {
      clearInterval(internalIdRef.current);
    }
    if (isRunning) {
      setIsRunning(false);
    }
  }
  useEffect(function () {
    savedCallback.current = callback;
  });
  useEffect(function () {
    function tick() {
      savedCallback.current && savedCallback.current();
    }
    if (intervalDuration !== null && isRunning) {
      var id = setInterval(tick, intervalDuration);
      internalIdRef.current = id;
      return function () {
        internalIdRef.current = null;
        clearInterval(id);
      };
    }
    return function () {};
  }, [intervalDuration, isRunning]);
  return {
    start: start,
    stop: stop
  };
};

export { useIntervalTrigged };
